import axios, { AxiosError, AxiosResponse } from "axios";
import * as Sentry from "@sentry/nextjs";

export const api = axios.create();

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    Sentry.withScope((scope: Sentry.Scope) => {
      scope.setExtra("data", { error, reason: error.response?.data });
      Sentry.captureException(error);
    });
    return Promise.reject(error);
  }
);
